import { render, staticRenderFns } from "./title_darkred.vue?vue&type=template&id=7931d277&scoped=true&"
import script from "./title_darkred.vue?vue&type=script&lang=js&"
export * from "./title_darkred.vue?vue&type=script&lang=js&"
import style0 from "./title_darkred.vue?vue&type=style&index=0&id=7931d277&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7931d277",
  null
  
)

export default component.exports